import React from 'react';
import SkeletonCard from './SkeletonCard';
import './loading.css';

const SkeletonList = ({ count = 6 }) => (
  <div className="skeleton-grid" aria-busy="true" aria-live="polite">
    {Array.from({ length: count }, (_, index) => (
      <SkeletonCard key={index} />
    ))}
  </div>
);

export default SkeletonList;
